/**
 * Updates the user profile in local storage and notifies other tabs/windows
 * @param {Object} userData - User data from NBC Identity SDK
 */
export const updateUserProfile = (userData) => {
  const savedProfile = JSON.parse(localStorage.getItem("userProfile"));
  const userProfile = {
    ...savedProfile,
    isLoggedIn: true,
    // NBC Identity SDK mapping
    email: userData?.mail || userData?.email || '',
    firstName: userData?.givenName || userData?.firstName || userData?.given_name || '',
    lastName: userData?.sn || userData?.lastName || userData?.family_name || '',
    userId: userData?._id || userData?.userId || '',
    hasCompletedProfile: userData?.hasCompletedProfile || userData?.profile_completed || false,
    preferences: userData?.preferences || {}
  };


  // Save to local storage
  localStorage.setItem('userProfile', JSON.stringify(userProfile));
  
  // Notify other tabs/windows
  window.dispatchEvent(new StorageEvent('storage', {
    key: 'userProfile',
    newValue: JSON.stringify(userProfile),
    storageArea: localStorage
  }));

  return userProfile;
};
